import React, { useEffect, useState, Suspense, lazy } from 'react'
import { connect } from 'react-redux'
import { Routes, Route, Navigate } from 'react-router-dom'

import { ConfigProvider, Spin } from 'antd'
import { Wrapper, PageContent, PageWrapper } from './style'

import Header from '../../common/header'

import enUS from 'antd/es/locale/en_US'
import zhCN from 'antd/es/locale/zh_CN'
import jaJP from 'antd/es/locale/ja_JP'

const Menu = lazy(() => import(/* webpackChunkName: 'menu' */'../../common/menu'))
const Footer = lazy(() => import(/* webpackChunkName: 'footer' */'../../common/footer'))
const Home2 = lazy(() => import(/* webpackChunkName: 'home' */'../../pages/Home2'))
const Home = lazy(() => import(/* webpackChunkName: 'home' */'../../pages/Home'))
const DeviceAnalyse = lazy(() => import(/* webpackChunkName: 'deviceAnalyse' */'../../pages/deviceAnalyse'))
const DeviceReport = lazy(() => import(/* webpackChunkName: 'deviceReport' */'../../pages/deviceReport'))
const PsInfo = lazy(() => import(/* webpackChunkName: 'PsInfo' */'../../pages/PsInfo'))
const Alarm = lazy(() => import(/* webpackChunkName: 'Alarm' */'../../pages/Alarm'))
const Report = lazy(() => import(/* webpackChunkName: 'Report' */'../../pages/Report'))
const PsInfoCompare = lazy(() => import(/* webpackChunkName: 'psInfoCompare' */'../../pages/psInfoCompare'))
const DeviceCompare = lazy(() => import(/* webpackChunkName: 'deviceCompare' */'../../pages/deviceCompare'))
const Helper = lazy(() => import(/* webpackChunkName: 'deviceCompare' */'../../pages/Helper'))
const PsTrans = lazy(() => import(/* webpackChunkName: 'PsInfo' */'../../pages/PsTrans'))
const Command = lazy(() => import(/* webpackChunkName: 'PsInfo' */'../../pages/Command'))
const DeviceManagement = lazy(() => import(/* webpackChunkName: 'deviceManagement' */'../../pages/deviceManagement'))
const MarketData = lazy(() => import(/* webpackChunkName: 'MarketData' */'../../pages/MarketData'))
const MarketIncome = lazy(() => import(/* webpackChunkName: 'MarketIncome' */'../../pages/MarketIncome'))

/**
 * 功能：根据当前电站类型与加载状态返回首页组件，避免站型未确认时误渲染错误首页。
 * 参数含义：
 * psType：当前选中电站的类型编号，用于区分普通电站首页与高压电站首页。
 * isPsInfoLoading：电站信息是否仍在初始化加载中，用于控制首屏是否先展示加载态。
 * 返回值：返回首页路由对应的 React 节点。
 * 异常 / 注意事项：电站类型尚未确认时，必须先展示加载态，避免高压电站首屏闪现普通电站页面。
 */
const renderHomePage = (psType, isPsInfoLoading) => {
    // 电站类型尚未确认时先展示加载态，避免错误首页先渲染出来再被替换。
    if (isPsInfoLoading) {
        return renderPageSpin()
    }

    return psType === 14 ? <Home2 /> : <Home />
}

/**
 * 功能：渲染页面级加载动画，统一首页初始化与路由懒加载阶段的视觉表现。
 * 参数含义：无。
 * 返回值：返回居中展示的 antd Spin 组件节点。
 * 异常 / 注意事项：这里使用固定最小高度，是为了在首页数据尚未返回时仍然保持加载态稳定居中，避免页面抖动。
 */
const renderPageSpin = () => {
    return (
        <div
            style={{
                minHeight: '240px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Spin size='large' tip='加载中...' />
        </div>
    )
}

/**
 * 功能：渲染系统主体内容，并根据语言与电站类型切换页面展示。
 * 参数含义：
 * props：Redux 注入的属性集合，包含菜单状态、语言、电站类型与电站加载状态。
 * 返回值：返回页面主体的 React 结构。
 * 异常 / 注意事项：首页路由需要等待电站信息完成初始化后再选择具体页面，避免首屏闪屏。
 */
const Content = (props) => {
    const [locale, setLocal] = useState(null);
    //切换语言
    useEffect(() => {
        switch (props.language) {
            case 'zh-cn':
                setLocal(zhCN)
                break;
            case 'ja-jp':
                setLocal(jaJP)
                break;
            case 'en-us':
                setLocal(enUS)
                break;
            default: setLocal(zhCN); break;
        }
    }, [props.language])

    useEffect(() => {
        console.log('props.psType', props.psType)
        //window.location.reload();
    }, [props.psType])

    return (
        <>
            <Header />
            <Menu />
            <ConfigProvider locale={locale}>
                <Wrapper >
                    <PageWrapper className={`page-wrapper ${props.collapsed ? 'toggled' : ''}`}  >
                        <PageContent>
                            <Suspense fallback={renderPageSpin()}>
                                {/*<Routes>
                                    <Route path='/' element={<Home/>} />
                                    <Route path='/page/home' element={<Home />}></Route>
                                    <Route path='about' element={<About />}></Route>
                                    <Route path='/deviceReport' element={<deviceReport />}></Route>
                                </Routes>*/}
                                {/* 注册路由 */}
                                <Routes>
                                    <Route path='/home' element={renderHomePage(props.psType, props.isPsInfoLoading)} />
                                    <Route path='/psinfo' element={<PsInfo />} />
                                    <Route path='/report' element={<Report />} />
                                    <Route path='/helper' element={<Helper />} />

                                    <Route path='/psInfoCompare' element={<PsInfoCompare />}></Route>
                                    <Route path='/deviceReport' element={<DeviceReport />}></Route>
                                    <Route path='/deviceAnalyse' element={<DeviceAnalyse />}></Route>
                                    <Route path='/alarm' element={<Alarm />}></Route>
                                    <Route path='/deviceCompare' element={<DeviceCompare />}></Route>

                                    <Route path='/psTrans' element={<PsTrans />}></Route>
                                    <Route path='/command' element={<Command />}></Route>
                                    <Route path='/deviceManagement' element={<DeviceManagement />}></Route>
                                    <Route path='/marketData' element={<MarketData />}></Route>
                                    <Route path='/marketIncome' element={<MarketIncome />}></Route>
                                    <Route path='*' element={<Navigate to='404' />} />
                                </Routes>
                            </Suspense>
                        </PageContent>
                    </PageWrapper>
                </Wrapper>
                <Footer />
            </ConfigProvider>
        </>
    )
}

/**
 * 功能：从 Redux 状态树中提取内容区域渲染所需的属性。
 * 参数含义：
 * state：Redux 的根状态对象。
 * 返回值：返回内容区域组件使用的属性集合。
 * 异常 / 注意事项：电站加载状态会直接影响首页首屏渲染策略。
 */
const mapState = (state) => {
    return {
        collapsed: state.getIn(['menu', 'collapsed']),
        language: state.getIn(['header', 'global', 'language']),
        psType: state.getIn(['header', 'psinfoList', 'psInfo', 'psTypeId']),
        isPsInfoLoading: state.getIn(['header', 'psinfoList', 'isLoad']),
    }
}

export default connect(mapState, null)(Content) 
